import { render, staticRenderFns } from "./CardiomiopatieEdit.vue?vue&type=template&id=e4dd8b40&scoped=true"
import script from "./CardiomiopatieEdit.vue?vue&type=script&lang=js"
export * from "./CardiomiopatieEdit.vue?vue&type=script&lang=js"
import style0 from "./CardiomiopatieEdit.vue?vue&type=style&index=0&id=e4dd8b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4dd8b40",
  null
  
)

export default component.exports